import { useEffect, useState } from 'react';

import { useLanguageStore } from '$/store/languageStore/index';
import soraIcon from './images/sora.png';
import nanoBananaIcon from './images/banana.png';
import { CardType } from './useCardType';

interface NoticeFloatCardConfig {
    title: string;
    icon: string;
    content: string;
    closeButtonText: string;
    confirmButtonText: string;
}

const configTextKeys = {
    sora: {
        title: 'roboneo_tips_sora2_1',
        icon: soraIcon,
        content: 'roboneo_tips_sora2_2',
        closeButtonText: 'roboneo_tips_sora2_3',
        confirmButtonText: 'roboneo_tips_sora2_3',
    },
    nano_banana: {
        title: 'roboneo_web_nanobanana2_launched',
        icon: nanoBananaIcon,
        content: 'roboneo_web_unlimited_members',
        closeButtonText: 'roboneo_web_gotit',
        confirmButtonText: 'roboneo_web_gotit',
    },
};

const defaultConfig: NoticeFloatCardConfig = {
    title: '',
    icon: '',
    content: '',
    closeButtonText: '',
    confirmButtonText: '',
};

export const useNoticeFloatCardConfig = (cardType: CardType | null) => {
    const [config, setConfig] = useState<NoticeFloatCardConfig>(defaultConfig);
    const languageStore = useLanguageStore((state) => state.languageStore);

    useEffect(() => {
        if (cardType && configTextKeys[cardType]) {
            setConfig({
                title: languageStore.smartcatTranslationText((v) => v[configTextKeys[cardType].title as keyof typeof v]),
                icon: configTextKeys[cardType].icon,
                content: languageStore.smartcatTranslationText((v) => v[configTextKeys[cardType].content as keyof typeof v]),
                closeButtonText: languageStore.smartcatTranslationText((v) => v[configTextKeys[cardType].closeButtonText as keyof typeof v]),
                confirmButtonText: languageStore.smartcatTranslationText((v) => v[configTextKeys[cardType].confirmButtonText as keyof typeof v]),
            });
        } else {
            setConfig(defaultConfig);
        }
  }, [cardType]);
  
  return config;
};